import genericAvatar from "assets/images/generic_avatar.jpg";
import { ErrorModal, PageContainer } from "components";
import { resetToggles } from "components/Navigation";
import { PartnerSchoolSecondaryInfo } from "components/reusables";
import { AddEditPartnerSchoolModal } from "components/reusables/AddEditModals/AddEditPartnerSchoolModal";
import React, { useCallback, useState } from "react";
import { useAsync } from "react-async";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import Img from "react-cool-img";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { getPartnerSchoolStory } from "services";
import { URLPaths } from "utilities";

export function PopoverPartnerSchoolDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [isShowingEditPartnerSchoolModal, setIsShowingEditPartnerSchoolModal] = useState(false);
  const promiseFn = useCallback(() => getPartnerSchoolStory(id), [id]);
  const { data, error, isPending } = useAsync({ promiseFn });
  const partnerSchool = data;
  const history = useHistory();

  const handleClick = () => {
    history.push("/map");
    resetToggles();
  };

  if (!partnerSchool && !isPending) return <Redirect to={URLPaths.map} />;

  return (
    <>
      <PageContainer>
        <div>
          {isPending ? (
            <Spinner animation="border" />
          ) : (
            partnerSchool && (
              <Row>
                <Col xs={3}>
                  <Img
                    src={partnerSchool.photoUrl || ""}
                    placeholder={genericAvatar}
                    alt={`${partnerSchool.organization}`}
                    width="100%"
                    loading="lazy"
                    className="img-circle"
                  />
                  <hr />
                  <PartnerSchoolSecondaryInfo partnerSchool={partnerSchool} direction="column" />
                  <hr />
                  {/* Sue didn't want any contact info to be displayed. We also took it off the input form.                
                  <PartnerSchoolContactInfo partnerSchool={partnerSchool} /> */}
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <h1>{partnerSchool.schoolName}</h1>
                    </Col>

                    <Col xs="auto">
                      <Button onClick={handleClick} variant="outline-danger">
                        Go Back
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col xs={8}>
                      <h4>About</h4>
                      <p className="p-breaks">{partnerSchool.description}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
          )}
          <ErrorModal error={error} />
        </div>
      </PageContainer>
      {!!partnerSchool && (
        <AddEditPartnerSchoolModal
          show={isShowingEditPartnerSchoolModal}
          setShow={setIsShowingEditPartnerSchoolModal}
          currentPartnerSchool={partnerSchool}
        />
      )}
    </>
  );
}
